(() => {
  'use strict';
  const root = document.querySelector('[data-compact-evidence]');
  if (!root) return;
  const areaButtons = [...root.querySelectorAll('[data-map-area]')];
  const groups = [...root.querySelectorAll('[data-map-ingredients]')];
  const ingredients = [...root.querySelectorAll('[data-map-ingredient]')];
  const details = [...root.querySelectorAll('[data-map-detail]')];
  const bases = [...root.querySelectorAll('[data-map-base]')];
  const status = root.querySelector('[data-map-status]');
  const areaImage = root.querySelector('.compact-area-image');
  const inset = root.querySelector('.compact-ingredient-inset img');
  const labels = {joints:'Joints',muscles:'Muscles',feel:'Feel & comfort'};
  const art = {joints:'joints',muscles:'muscles',feel:'nerves'};
  const alts = {feel:'Illustrative sensory nerve pathways in the shoulder and upper arm',joints:'Illustrative cross section of the shoulder joint',muscles:'Illustrative muscle fibres in the shoulder and upper arm'};
  const stem = (() => { const s = areaImage && (areaImage.getAttribute('src') || ''); const m = s.match(/^(.*?)evidence-explorer-[a-z]+-\d+\.webp/); return m ? m[1] + 'evidence-explorer-' : '/assets/evidence-explorer/'; })();
  let currentArea = 'joints';
  function choose(area, ingredient, persist = true) {
    if (!labels[area]) area = 'joints';
    const group = groups.find(g => g.dataset.mapIngredients === area);
    const options = [...group.querySelectorAll('[data-map-ingredient]')];
    const selected = options.find(b => b.dataset.mapIngredient === ingredient) || options[0];
    const key = selected.dataset.mapIngredient;
    currentArea = area;
    areaButtons.forEach(b => b.setAttribute('aria-pressed',String(b.dataset.mapArea === area)));
    groups.forEach(g => {g.hidden = g !== group;});
    ingredients.forEach(b => b.setAttribute('aria-pressed',String(b === selected)));
    details.forEach(d => {d.hidden = d.dataset.mapDetail !== key;});
    bases.forEach(b => {b.hidden = b.dataset.mapBase !== 'shared' && b.dataset.mapBase !== (area === 'muscles' ? 'muscle-aid' : 'ultimate');});
    status.textContent = labels[area];
    root.dataset.area = area;
    if (areaImage.dataset.activeArea !== area) {
      areaImage.srcset = [640,960,1374].map(w => stem+art[area]+'-'+w+'.webp '+w+'w').join(', ');
      areaImage.src = stem+art[area]+'-960.webp';
      areaImage.alt = alts[area];
      areaImage.dataset.activeArea = area;
    }
    const thumb = selected.querySelector('img');
    inset.src = thumb.src;
    inset.alt = selected.querySelector('span').textContent;
    if (persist) {
      const url = new URL(location.href);
      url.searchParams.set('evidence_area',area);
      url.searchParams.set('evidence_ingredient',key);
      history.replaceState(null,'',url.pathname+url.search+url.hash);
    }
  }
  function restore() {
    const url = new URL(location.href);
    choose(url.searchParams.get('evidence_area'),url.searchParams.get('evidence_ingredient'),false);
  }
  areaButtons.forEach(b => b.addEventListener('click',() => choose(b.dataset.mapArea)));
  ingredients.forEach(b => b.addEventListener('click',() => {
    choose(currentArea,b.dataset.mapIngredient);
    if (window.matchMedia('(max-width:700px)').matches) {
      const active = details.find(d => !d.hidden);
      active.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
  }));
  window.addEventListener('popstate',restore);
  window.addEventListener('pageshow',restore);
  restore();
})();
